import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'number_slice',
    standalone: false
})
export class NumberSlicePipe implements PipeTransform {
  transform(value: number) : string {
    return ("0" + value).slice(-2);
  }
}